import PropTypes from 'prop-types';

export const existences = PropTypes.shape({
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  age: PropTypes.number,
  existences: PropTypes.shape({
    treeFeet: PropTypes.number,
    height: PropTypes.number,
    basometricArea: PropTypes.number,
    volumeWithBark: PropTypes.number,
    volumeWithoutBark: PropTypes.number,
    biomass: PropTypes.number,
    start_date: PropTypes.number,
    end_date: PropTypes.number
  })
});